var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"org-select-tree-list"},[_c('org-tree',_vm._b({ref:"orgTree",attrs:{"selected":_vm.currentSelected,"cust-get-tree-data":_vm.custGetTreeData},on:{"selectedChange":_vm.selectedChange}},'org-tree',_vm.$attrs,false))],1)}
var staticRenderFns = []

export { render, staticRenderFns }